<article class="page__item">
  <div class="box notification">
    @if (notification$ | async; as notification) {
      <header class="notification__header">
        <button
          class="notification__back-btn button button--link-blue"
          (click)="navigateBack()"
        >
          <fa-icon [icon]="faChevronLeft"></fa-icon>
          <p>{{ 'BACK' | translate }}</p>
        </button>
        <p class="date">
          {{ dayjs(notification?.created_at).format('DD.MM.YYYY HH:mm') }}
        </p>
      </header>
      <section class="notification__item">
        @if (notification.template?.preview_url && !showFallbackImage) {
          <img
            [src]="notification.template.preview_url"
            (error)="enableFallbackImg()"
            alt="Notification image"
            class="image"
          />
        } @else {
          <img
            src="assets/img/icons/no-image.svg"
            alt="Notification fallback"
            class="image"
          />
        }
        <div class="info-block">
          <p class="title clamp-3">{{ notification.title }}</p>
          <div
            class="markdown"
            [innerHTML]="notification.template?.message | markdown"
          ></div>
        </div>
      </section>
    } @else {
      <div class="text-secondary text-center">
        <div class="spinner-border spinner-border-lg" role="status">
          <span class="sr-only">{{ 'LOADING' | translate }}</span>
        </div>
      </div>
    }

    <ng-template #spinner>
      <div class="text-secondary text-center">
        <div class="spinner-border spinner-border-lg" role="status">
          <span class="sr-only">{{ 'LOADING' | translate }}</span>
        </div>
      </div>
    </ng-template>
  </div>
</article>
